import { useMutation } from '@tanstack/react-query'
import { cancelSubscriptionFeedback } from '@mindfulchefuk/features/Subscription/services/cancelSubscriptionFeedback'

export const useCancelSubscriptionFeedback = () =>
  useMutation({
    mutationFn: cancelSubscriptionFeedback,
  })
